import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum OTPFLOW {
  APPLICATION,
  STATUS,
}

export interface OtpScreenState {
  isWrongOTPCode: boolean;
  flow: OTPFLOW;
  reachedMaxRetries: boolean;
  isIncorrectOtpCode: boolean;
}

const initialState: OtpScreenState = {
  isWrongOTPCode: false,
  flow: OTPFLOW.APPLICATION,
  reachedMaxRetries: false,
  isIncorrectOtpCode: false,
};

const otpScreenSlice = createSlice({
  name: 'otpScreen',
  initialState,
  reducers: {
    wrongOtpCode: (state, action: PayloadAction<boolean>) => {
      state.isWrongOTPCode = action.payload;
    },
    setOtpFlow(state, action: PayloadAction<OTPFLOW>) {
      state.flow = action.payload;
    },
    setReachedMaxRetries(state, action: PayloadAction<boolean>) {
      state.reachedMaxRetries = action.payload;
    },
    setIncorrectOtpCode: (state, action: PayloadAction<boolean>) => {
      state.isIncorrectOtpCode = action.payload;
    },
  },
});

export const {
  wrongOtpCode,
  setOtpFlow,
  setReachedMaxRetries,
  setIncorrectOtpCode,
} = otpScreenSlice.actions;

export default otpScreenSlice.reducer;
